import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import SectionTitle from '../../property-partners-portal/components/SectionTitle/SectionTitle';
import { useAccountInformation } from '../../contexts/AccountInformationContext';
import CardPlaceholder from '../components/CardPlaceholder';
import ReadOnlyView from './ReadOnlyView';
import EditView from './EditView';
import '../../stylesheets/presentationCards.scss';
import TermsAndConditionsViewPopUp from '../../termsAndConditions/TermsAndConditionsViewPopUp';
import TermsAndConditionsAcceptedInfo from './TermsAndConditionsAcceptedInfo';
import GoBackHomeLink from '../GoBackHomeLink';
import Card from '../../muiComponents/Card';
import { ProfileViewMode } from '../../types/profile/profileTypes';

const AccountInformationContainer = () => {
    const { viewMode, isLoadingAccountInformation, handleViewModeChange } =
        useAccountInformation();
    const [isOpenPopUp, setIsOpenPopUp] = useState(false);

    useEffect(() => {
        return () => handleViewModeChange(ProfileViewMode.READ_ONLY);
    }, [handleViewModeChange]);

    const handleOpenPopUp = () => {
        setIsOpenPopUp(true);
    };

    return (
        <div className='account-info__container'>
            <div className='page-title__container'>
                <SectionTitle title={'account_info'} />
                <GoBackHomeLink loading={isLoadingAccountInformation} />
            </div>
            {isLoadingAccountInformation ? (
                <CardPlaceholder height='500px' />
            ) : (
                <Card className='padding40 flex-column gap-30'>
                    {viewMode === ProfileViewMode.READ_ONLY ? (
                        <ReadOnlyView />
                    ) : (
                        <EditView />
                    )}
                </Card>
            )}

            <Typography variant='body1'>
                <TermsAndConditionsAcceptedInfo
                    handleOpenPopUp={handleOpenPopUp}
                />
            </Typography>

            <TermsAndConditionsViewPopUp
                isOpenPopUp={isOpenPopUp}
                setIsOpenPopUp={setIsOpenPopUp}
            />
        </div>
    );
};

export default AccountInformationContainer;
